/**
 * Converte os dados de um endereço em uma `string` legível.
 * @param address dados do endereço a ser convertido.
 */
export const formatAddress = (address: Queries.AddressInfoFragment) => {
  const { street, number, complement, neighborhood, city, state, postalCode } = address
  return `${street}, ${number}, ${complement}, ${neighborhood}, ${city}/${state} - ${postalCode}`
}
